<template>
    <div class="image-control field">
        <div v-if="image === null" class="level">
            <div class="level-left">
                <div class="level-item">
                    <div class="no-image">
                        No Image
                    </div>
                </div>
                <div class="level-item">
                    <a @click="selecting = true">Select image</a>
                </div>
            </div>
        </div>
        <div v-if="image !== null && !selecting" class="level">
            <div class="level-left">
                <div class="level-item">
                    <img :src="image.thumbnail_path">
                </div>
                <div class="level-item">
                    <div>
                        {{ image.name }}.{{ image.extension }}
                        <div>
                            <a @click="selecting = true">Change image</a>
                            <div>
                                <a @click="clearImage()">Clear image</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selecting">
            <div class="has-text-centered">
                <a @click="selecting = false">Cancel</a>
            </div>
            <div class="image-list">
                <div v-for="img in images" class="image-tile" @click="selectImage(img)">
                    <div class="level" style="height: 50px">
                        <div class="level-left">
                            <div class="level-item">
                                <img :src="img.thumbnail_path" style="max-width: 50px">
                            </div>
                            <div class="level-item image-description">
                                {{ img.name }}.{{ img.extension }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss">
    .no-image {
        width: 128px;
        height: 128px;
        background: #EEE;
        line-height: 128px;
        text-align: center;
    }

    .image-list {
        font-size: 0;
    }

    .image-tile {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 50%;
        height: 50px;
        padding: 0 0.5rem;
        margin-bottom: 1rem;
        font-size: 1rem;
        user-select: none;
        &:hover {
            background: #FFE2E8;
            cursor: pointer;
        }
    }

    .image-description {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .is-24x24-max {
        text-align: center;
        min-height: 24px;
        min-width: 24px;
        line-height: 24px;
        img { max-height: 24px; max-width: 24px; }
    }

    .is-48x48-max {
        text-align: center;
        min-height: 48px;
        min-width: 48px;
        line-height: 48px;
        img { max-height: 48px; max-width: 48px; }
    }

    .is-64x64-max {
        text-align: center;
        min-height: 64px;
        min-width: 64px;
        line-height: 64px;
        img { max-height: 64px; max-width: 64px; }
    }

    .is-128x128-max {
        text-align: center;
        min-height: 128px;
        min-width: 128px;
        line-height: 128px;
        img { max-height: 128px; max-width: 128px; }
    }

    .is-256x256-max {
        text-align: center;
        min-height: 256px;
        min-width: 256px;
        line-height: 256px;
        img { max-height: 256px; max-width: 256px; }
    }
</style>

<script>
    import {mapGetters} from "vuex"
    export default {
        props: {
            imageId: {type: [Number], default: null},
        },
        mounted() {
            if (this.imageId !== null) {
                this.image = this.images.find(image => image.id === this.imageId)
            }
        },
        data() {
            return {
                image: null,
                selecting: false,
            }
        },
        computed: mapGetters(['images']),
        methods: {
            selectImage(image) {
                this.image     = image;
                this.selecting = false;
                this.emitOtherEvent('input', image.id)
            },
            clearImage() {
                this.image = null;
                this.emitOtherEvent('input', null)
            },
            emitOtherEvent(type, payload) {
                if (type === 'input') this.$emit('input', payload)

                this.$emit('event', {type, payload, target: this.id})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ImageControl.vue?044b0b35